<script async setup>
import { defineProps } from "vue";

const props = defineProps({
    fill: {
        type: String,
        default: "current",
    },
    viewbox: {
        type: String,
        default: "0 0 64 64",
    },
    size: {
        type: [String, Number, Object],
        default: 64,
    },
    width: {
        type: [String, Number],
        default: "",
    },
    height: {
        type: [String, Number],
        default: "",
    },
    
});

const fillColors = {
    white: "#fff",
    black: "#000",
    red: "#D90000",
    current: "currentColor",
    none: null,
};
</script>

<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        :viewBox="props.viewbox"
        :width="props.width ? props.width : (props.size ? props.size : '24')"
        :height="props.width ? props.height : (props.size ? props.size : '24')"
    >
        <slot :fill="fillColors[fill]" />
    </svg>
</template>
